import { EmptyState } from 'ui/emptyState';
import { NoResult } from 'ui/illustrations';
import { EmptyStateWrapper } from './SimpleTable.styled';

type Props = {
  pluralResourceName: string;
};

export const ZeroState = ({ pluralResourceName }: Props) => {
  const title = `Hm... we couldn't find any ${pluralResourceName} for you`;
  return (
    <EmptyStateWrapper data-test="simple-table-zero-state">
      <EmptyState
        title={title}
        subtitle="Try a new set of filters and see if that helps."
        Illustration={() => <NoResult width={150} height={150} />}
      />
    </EmptyStateWrapper>
  );
};
